import { Documents } from '../api/types'
import {
  GET_DOCUMENTS,
  GET_DOCUMENTS_FAILURE,
  GET_DOCUMENTS_SUCCESS,
  CLEAR_DOCUMENTS,
} from '../actions'

interface DocumentsReducer {
  loadingDocuments: boolean
  documents?: Documents
  errorMessage?: string
}

const INITIAL_STATE: DocumentsReducer = {
  documents: undefined,
  loadingDocuments: true,
}

export const documentsReducer = (
  state: DocumentsReducer = INITIAL_STATE,
  action: { type: string; documents: Documents; errorMessage?: string }
): DocumentsReducer => {
  const { type, documents, errorMessage } = action
  switch (type) {
    case GET_DOCUMENTS:
      return { ...INITIAL_STATE, loadingDocuments: true }
    case GET_DOCUMENTS_SUCCESS:
      return { ...state, loadingDocuments: false, documents }
    case GET_DOCUMENTS_FAILURE:
      return { ...state, loadingDocuments: false, errorMessage }
    case CLEAR_DOCUMENTS:
      return INITIAL_STATE
    default:
      return state
  }
}
